import type { CustomFormats } from 'react-intl'

export const intlFormats: CustomFormats = {
	number: {
		'decimal-2': {
			style: 'decimal',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		integer: {
			style: 'decimal',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
		'integer-currency': {
			style: 'currency',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		},
		'decimal-2-currency': {
			style: 'currency',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		},
		'decimal-3-currency': {
			style: 'currency',
			minimumFractionDigits: 3,
			maximumFractionDigits: 3,
		},
	},
	date: {
		full: {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
		},
		'month-year': {
			month: 'long',
			year: 'numeric',
		},
		'date-month': {
			day: 'numeric',
			month: 'long',
		},
		'date-month-short': {
			day: 'numeric',
			month: 'short',
		},
		'date-month-year-short': {
			day: 'numeric',
			month: 'short',
			year: 'numeric',
		},
		'short-weekday': {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric',
			weekday: 'long',
		},
		'weekday-month': {
			weekday: 'long',
			day: 'numeric',
			month: 'long',
		},
		'long-time': {
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric',
		},
		'short-date': {
			month: 'numeric',
			day: 'numeric',
			year: 'numeric',
		},
		'short-date-time': {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		},
		'month-and-time': {
			day: '2-digit',
			month: 'short',
			hour: '2-digit',
			minute: '2-digit',
		},
	},
	time: {
		full: {
			day: 'numeric',
			month: 'long',
			year: 'numeric',
		},
		'month-year': {
			month: 'long',
			year: 'numeric',
		},
		'date-month': {
			day: 'numeric',
			month: 'long',
		},
	},
}
